import styled from 'styled-components';

export const HomeContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: 100vh;
`;


export const Content = styled.div`
with: 100vw;
display: flex;
align-items: center;
justify-content: center;
`;

export const Input = styled.input`
border: 1px solid #ddd;
height: 1.5rem;
padding: 0 5rem;
border-radius: .25rem 0 0 .25rem;

&: focus,
&:active {
    outline: none;
    box-shadow:none;
}
`;

export const Button = styled.button`
height: 1.5rem;
border: 1px double;
color: white;
border-radius: 0 .25rem .25rem 0;
background: gray;
border-radius: .30rem;

&: focus,
&:active {
outline: none;
box-shadow:none;
}
`;

export const ErrorMsg = styled.span`
  display: block;
  font-size: 0.65rem;
  color: red;
  font-weight: 600;
  margin-top: 1rem;
`
